import * as React from "react";
import { ContentDatePicker } from "../../../../../../Shared/Entities/Constants/DateConstants";
// import { BatchType } from "../../../../../../Wrap/Constants/Enums/Orders/Batch/BatchType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { DatePicker } from "../../../../../../../react-core/Datepicker/DatePicker";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { datePickerOptions } from "../../../Common/Resource/Contents";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { BatchType } from "../../../../../../../Wrap/Constants/Enums/Orders/Batch/BatchType";

interface ISwitchOrderSetupProps extends IProcessComponentProps {
    type: SubAccountType;
}

interface ISwitchOrderSetupState {
    isOrderTypeInitialized: boolean;
}

export class SwitchOrderSetup extends ProcessComponent<ISwitchOrderSetupProps, ISwitchOrderSetupState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isOrderTypeInitialized: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
        const today = new Date();
        if (!this.state.isOrderTypeInitialized) {
            this.props.onChange({
                OrderType: BatchType.OneOff
            });
            this.setState({ isOrderTypeInitialized: true });
        }

        if (!this.props.data?.Contribution?.SwitchInstructionModel) {
            this.props.onChange({
                Contribution: {
                    ...this.props.data?.Contribution,
                    SwitchInstructionModel: {
                        SellAllocations: [],
                        BuyAllocations: [],
                        ActionDate: JsonDateParser.toJsonDate(today)
                    }
                }
            });
        } else if (!this.props.data?.Contribution?.SwitchInstructionModel?.ActionDate) {
            this.props.onChange({
                Contribution: {
                    ...this.props.data.Contribution,
                    SwitchInstructionModel: {
                        ...this.props.data.Contribution.SwitchInstructionModel,
                        ActionDate: JsonDateParser.toJsonDate(today)
                    }
                }
            });
        }
    }

    isValid() {
        return super.isValid() && !!this.props.data?.Contribution?.SwitchInstructionModel?.ActionDate;
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;

        return (
            <>
                <h2 className="mb-18">
                    <span>Order setup</span>
                </h2>

                <TextBoxEditor
                    cssWrapper="control-size-430"
                    value={"One-off"}
                    label={"Order type"}
                    disabled={true}
                />

                <DatePicker
                    label="Action date"
                    formGroupCssWrapper="control-size-245"
                    selected={JsonDateParser.toDateNoOffset(data?.Contribution?.SwitchInstructionModel?.ActionDate)}
                    onChange={(v) => 
                        onChange({
                            Contribution: {
                                ...data.Contribution,
                                SwitchInstructionModel: {
                                    ...data.Contribution.SwitchInstructionModel,
                                    ActionDate: JsonDateParser.toJsonDate(v)
                                }
                            }
                        })
                    }
                    atLeast={{
                        value: new Date(),
                        errorMessage: ContentDatePicker.CannotBeInThePast,
                    }}
                    required="Please select action date"
                    defaultValue={new Date()}
                    {...datePickerOptions}
                />
            </>
        );
    }
}